import React, { useState, useRef } from 'react';
import { IoCopyOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import AccountSetupButton from '../../../../common/AccountSetupButton';
import ChatPreview from './ChatPreview';

interface widgetsubmitProps {
  isDisabled: boolean;
  handleCreateOrUpdateWidgets?: any;
  isSettings?: boolean | undefined;
  businessType: string | null;
  selectedTheme: string;
  menu: string[];
  imagePreview: any;
}

const WidgetsSubmit = (props: widgetsubmitProps) => {
  const {
    isDisabled,
    handleCreateOrUpdateWidgets,
    isSettings,
    businessType,
    selectedTheme,
    menu,
    imagePreview
  } = props;

  const navigate = useNavigate();
  const paragraphRef = useRef<HTMLParagraphElement>(null);
  const companyUuid = sessionStorage.getItem('companyUuid');
  const NodeEnv = process.env.REACT_APP_KEY;

  const [copied, setCopied] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const handleCopy = () => {
    try {
      if (paragraphRef.current) {
        const textToCopy = paragraphRef.current.textContent || '';
        navigator.clipboard
          .writeText(textToCopy)
          .then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
          })
          .catch((err) => {
            console.error('Failed to copy text: ', err);
          });
      }
    } catch (error) {
      console.log('Here copy is not supported');
      alert('Here copy is not supported Please copy Manualy');
    }
  };

  const handleNext = () => {
    if (isSettings) {
      handleCreateOrUpdateWidgets();
    } else {
      navigate('/account-setup/integration');
    }
  };

  return (
    <div className={`mt-5 ${isSettings ? 'px-4' : 'md:px-8 lg:px-8 px-1'}`}>
      {((businessType as string) !== 'Retail' && (businessType as string) !== 'WordpressRetail' && (businessType as string) !== 'OdooRetail') && (
        <div className="flow-root w-full bg-[#343434]  rounded-[10px] md:p-4 p-2   sm:text-[9px] sm:leading-[17.86px] md:text-[18px] md:leading-[21.9px] font-light">
          <button
            onClick={handleCopy}
            className="flex float-right items-center  bg-[#626262] py-[2px] px-[5px] rounded-[3px] gap-[10px] h-[24px] text-[#FFFFFF] text-[10px] leading-[10px]  md:text-xs  md:leading-[19.64px] font-normal"
          >
            <IoCopyOutline />
            Copy
          </button>
          <p ref={paragraphRef} className="lg:w-[100%] w-full md:text-base text-xs">
            <code className="text-blue-600">
              {`<script `}
              <span className="text-blue-600">{`type="text/javascript"`}</span>
              {/* {`\n  src="https://lopaa-io.vercel.app/embed.js?client_id=`} */}
              {`\n  src="https://chatbot.lopaa.io/embed.js?client_id=`}

              <span className="text-orange-500">
                {companyUuid}
                {NodeEnv === 'DEVELOPMENT' && `&env=DEV`}
              </span>
              {`"\n  async>\n</script>`}
            </code>
          </p>
        </div>
      )}
      {copied && (
        <span className="absolute left-[50%] sm:left-[50%] md:left-[50%] lg:left-[59%] bottom-10 transform -translate-x-1/2 bg-[#626262] text-white text-[10px] md:text-[16px] py-1 px-2 rounded animate-popup">
          Copied to clipboard
        </span>
      )}
      <div
        className={`flex justify-end gap-2 md:gap-4 bottom-0 right-8 ${businessType === 'Retail' || (businessType as string) === 'WordpressRetail' || (businessType as string) === 'OdooRetail' && 'absolute'}`}
      >
        {((businessType as string) === 'Retail' || (businessType as string) === 'WordpressRetail' || (businessType as string) === 'OdooRetail') ? (
          !isSettings && (
            <AccountSetupButton
              isFormValid={true}
              btnText="Skip"
              textColor="#FFFFFF"
              backGroundColor="#1E1E1E"
              borderColor="#006BEA"
              onClick={() => navigate('/account-setup/integration')}
            />
          )
        ) : (
          <AccountSetupButton
            isFormValid={true}
            btnText={showPreview ? 'Close' : 'Preview'}
            textColor="#FFFFFF"
            backGroundColor="#006BEA"
            borderColor="#006BEA"
            onClick={() => setShowPreview(!showPreview)}
          />
        )}
        <AccountSetupButton
          disable={isDisabled}
          isFormValid={true}
          btnText={`${isSettings ? 'Update' : 'Next'}`}
          textColor="#FFFFFF"
          backGroundColor="#006BEA"
          borderColor="#006BEA"
          onClick={handleNext}
        />
      </div>

      {showPreview && (
        <ChatPreview selectedTheme={selectedTheme} menu={menu} imagePreview={imagePreview} />
      )}

      {isDisabled && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-50 z-40"></div>

          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="loader border-t-4 border-[#006BEA] rounded-full w-12 h-12 animate-spin"></div>
          </div>
        </>
      )}
    </div>
  );
};

export default WidgetsSubmit;
